(function() {
  'use strict';

  angular.module('eclipseApp.checkout').factory('buyService', [
    '$rootScope',
    '$q',
    '$http',
    'uteEndpoint',
    'uteModal',
    '$timeout',
    '$state',
    '$window',
    'commonService',
    '$log',
    'notifier',
    'buyUtils',
    '$localStorage',
    'buySession',
    '$translate',
    'provinceMeta',
    'uteLocale',
    'env',
    'brtSwitchCMS',
    function(
      $rootScope,
      $q,
      $http,
      uteEndpoint,
      uteModal,
      $timeout,
      $state,
      $window,
      commonService,
      $log,
      notifier,
      buyUtils,
      $localStorage,
      buySession,
      $translate,
      provinceMeta,
      uteLocale,
      env,
      brtSwitchCMS
    ) {
      var buyService = {};
      var sessionKey = 'profile';
      var buyModeKey = 'mode_editting';

      var internetTvFlag = 'Internet/TV',
        internetFlag = 'Internet',
        wirelessFlag = 'Wireless',
        statusActiveFlag = 'active',
        statusOpenFlag = 'open';

      var internetPromoJson = null;

      var apis = {
        // mocks
        // searchCustomerDetails: 'http://localhost:8888/resource/searchCustomerDetails.json',
        // createContact: 'http://localhost:8888/resource/createContact.json',
        // creditCheck: 'http://localhost:8888/resource/creditCheck.json',
        // validateCart: 'http://localhost:8888/resource/validateShoppingCart.json',
        // fulfillmentOptions: 'http://localhost:8888/resource/fulfillmentOptions.json',
        // availableTimeslots: 'http://localhost:8888/resource/availableTimeslots.json',
        // submitfulfillmentOptions: 'http://localhost:8888/resource/submitfullfillmentOptions.json',
        // validateEquipment: 'http://localhost:8888/resource/validateEquipment.json',
        sessionFulfillmentOptions: 'http://localhost:8888/resource/sessionFulfillmentOptions.json',
        sessionCheckout: 'http://localhost:8888/resource/sessionCheckout.json',
        sessionConfirmation: 'http://localhost:8888/resource/orderConfirmation.json',

        searchCustomerDetails: uteEndpoint('v2/searchCustomerDetails'),
        createContact: uteEndpoint('v1/createContact'),
        creditCheck: uteEndpoint('v1/creditCheck'),
        validateCart: uteEndpoint('shoppingCart'),
        fulfillmentOptions: uteEndpoint('fullfillmentOptions'),
        availableTimeslots: uteEndpoint('availableTimeslots'),
        submitfulfillmentOptions: uteEndpoint('submitfullfillmentOptions'),
        getPaymentDetails: uteEndpoint('v1/getPaymentDetails'),
        promoJSONUrl:
          env.name === 'prod'
            ? 'cms/ute/fido/resource/internetPromo.json'
            : 'cms/ute/fido/resource/QA/internetPromo.json'
      };

      var createSession = function(sessionName, struct) {
        struct = struct || {};

        var data = angular.isObject(struct) ? angular.toJson(struct) : struct;

        sessionStorage.setItem(sessionName, data);

        return angular.fromJson(sessionStorage.getItem(sessionName));
      };

      var createTimeslots = function(startMomentDate) {
        var startDate = startMomentDate ? startMomentDate.startOf('day') : moment().startOf('day');
        startDate.add(3, 'days');
        var untilMomentDate = startMomentDate.clone().add(7, 'days');

        var days = {
          MOR: [],
          MID: [],
          NGT: [],
          AFT: []
        };
        var day = startMomentDate;
        var slotIndex = 0;

        while (day <= untilMomentDate) {
          var startOfDay = day.clone().hour(8);

          days.MOR.push({
            slotId: 'MOR',
            slotDescription: '8:00A - 11:00A',
            startTime: startOfDay.format(),
            endTime: startOfDay.add(3, 'hours').format(),
            appointmentAvailable: true,
            slotIndex: slotIndex++
          });

          days.MID.push({
            slotId: 'MID',
            slotDescription: '11:00A - 2:00P',
            startTime: startOfDay.format(),
            endTime: startOfDay.add(3, 'hours').format(),
            appointmentAvailable: true,
            slotIndex: slotIndex++
          });

          days.AFT.push({
            slotId: 'AFT',
            slotDescription: '2:00P - 5:00P',
            startTime: startOfDay.format(),
            endTime: startOfDay.add(3, 'hours').format(),
            appointmentAvailable: true,
            slotIndex: slotIndex++
          });

          days.NGT.push({
            slotId: 'NGT',
            slotDescription: '5:00P - 8:00P',
            startTime: startOfDay.format(),
            endTime: startOfDay.add(3, 'hours').format(),
            appointmentAvailable: true,
            slotIndex: slotIndex++
          });

          day = day.clone().add(1, 'd');
        }
        return days;
      };

      var getSession = function(name) {
        var session;

        session = angular.fromJson(sessionStorage.getItem(name));
        return session;
      };

      buyService.shoppingCartCached = {};

      buyService = {
        // session manager methods
        saveSession: function(sessionStoreName, data) {
          var value = JSON.stringify(data);
          sessionStorage.setItem(sessionStoreName, value);
        },
        getSession: function(sessionStoreName) {
          var savedSteps = sessionStorage.getItem(sessionStoreName);
          return savedSteps ? JSON.parse(savedSteps) : false;
        },

        // TBD:
        completeStep: function(stepName, data) {
          stepName = stepName || sessionKey;
          buyService.saveSession(stepName, data);
        },

        setStepTouched: function() {
          var _ns = getSession(sessionKey);
          _ns.fulfillment.techInstallTouched = true;
          buyService.saveSession(sessionKey, _ns);
        },
        setStepVisited: function(stepName, cb) {
          var _session = getSession(sessionKey);
          if (!_session) return;
          _session[stepName].visited = true;

          buyService.saveSession(sessionKey, _session);

          if (cb && _.isFunction(cb)) {
            cb();
          }
        },
        resetStep: function(stepName, force) {
          var _newSession = getSession(sessionKey);

          // default state specific to fulfillment
          var resetFulfillment = {
            __completed: false,
            selectedOption: 'shipToAddress',
            techInstallTouched: false,
            data: {},
            options: {
              techInstall: {},
              shipToAddress: {
                shippingAddressOption: 'serviceAddress'
              },
              pickupAtStore: {}
            }
          };

          // reset a given step-name
          if (_newSession) {
            if (stepName && stepName === 'fulfillment' && angular.isDefined(force) && force === true) {
              // reset fulfillment specific
              angular.extend(_newSession[stepName], resetFulfillment);
            } else {
              // reset other steps
              _newSession[stepName].__completed = false;
            }
          }

          // save to session after resets have been applied in cache
          buyService.saveSession(sessionKey, _newSession);
        },
        cleanSessions: function() {
          var session = _.mapValues(getSession(sessionKey), function(n) {
            n = { __completed: true };
            return n;
          });

          buyService.saveSession('profile', session);
        },
        hasSession: function(param) {
          if (param) {
            return angular.fromJson(sessionStorage.getItem(param));
          }
          return angular.fromJson(sessionStorage.getItem(sessionKey));
        },
        deleteSession: function(sessionKeyOrKeys, overrideParams) {
          overrideParams = overrideParams || {};
          overrideParams.force = overrideParams.force || false;

          /*
           * Note:
           * Deleting a session while outside checkout flow will need overrideParams.force=true
           *
           */

          if (!overrideParams.force && !$state.includes('buy')) return;

          if ($state.includes('buy') && buyService.getSession('confirmation')) return;

          if (angular.isArray(sessionKeyOrKeys) && sessionKeyOrKeys.length > 0) {
            angular.forEach(sessionKeyOrKeys, function(v) {
              sessionStorage.removeItem(v);
            });
          } else if (angular.isString(sessionKeyOrKeys)) {
            sessionStorage.removeItem(sessionKeyOrKeys);
          }
        },
        deleteCheckoutSession: function() {
          sessionStorage.removeItem(sessionKey);
          sessionStorage.removeItem('confirmation');
          sessionStorage.removeItem('fulfillment');
          sessionStorage.removeItem(buyModeKey);
        },
        isTypeOfFulfillmentSelected: function() {
          if (getSession(sessionKey)) {
            // check type of fulfillment option selected
            return getSession(sessionKey).fulfillment.selectedOption;
          }
        },

        /*
         * setter and getter for editting mode in checkout
         */
        getCheckoutMode: function() {
          return getSession(buyModeKey);
        },
        setCheckoutMode: function(boolFlag) {
          // check if mode flag is already created
          if (!getSession(buyModeKey)) {
            // console.log('@buyService:setCheckoutMode:if', boolFlag);

            // if key doesn't exist => create it
            boolFlag = boolFlag || false;
            createSession(buyModeKey, boolFlag);
          } else {
            // console.log('@buyService:setCheckoutMode:else');

            // if key already created => update value
            buyService.saveSession(buyModeKey, boolFlag);
          }
        },

        getCableCondition: function() {
          var cachedServiceableAddress =
            $localStorage[
              buySession.getCheckoutSessionKey(buySession.getKeyId('serviceableAddress', $rootScope.userPref.samKey))
            ];

          if (cachedServiceableAddress) {
            // console.log('@buyService:getCableCondition() ', cachedServiceableAddress.ssResp.cableCondition);
            return cachedServiceableAddress.ssResp.cableCondition;
          } else {
            _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
            _satellite.track('bfa-fhsi-error');
            $log.error(
              '@buyService:getCableCondition: an error occured while fetching cable condition, please try again'
            );
          }
        },

        // TODO: pending for endpoints
        getServiceAddressDetails: function() {
          var deferred = $q.defer();

          var session =
            $localStorage[
              buySession.getCheckoutSessionKey(buySession.getKeyId('serviceableAddress', $rootScope.userPref.samKey))
            ];

          session = session ? angular.fromJson(session) : false;

          if (session) {
            deferred.resolve(session);
          } else {
            deferred.reject();
          }

          return deferred.promise;
        },

        getExistingBillingAddressDetails: function(accountNumber) {
          var promise = $http.post(uteEndpoint('accountSummary'), { accountNumber: accountNumber });

          promise
            .success(function(res) {
              if (res.error) {
                _satellite.setVar('error', 'FHSI | Billing address failed');
                _satellite.track('bfa-fhsi-error');
                //notifier.notify.error({errorCode: res.error});
              }
            })
            .error(function(res, status) {
              switch (status) {
                case 500:
                case 5000:
                case 50000:
                  //notifier.notify.error({errorCode: status});
                  return;
                default:
              }

              //notifier.notify.error();
            });

          return promise;
        },

        getEndPointUrl: function(operationName) {
          return apis[operationName];
        },

        // handle nextOperations calls
        doOperation: function(operationName, params, loading) {
          var deferred = $q.defer();

          console.log('@buyService:doOperation(operationName, params) BEFORE ', operationName, params);

          /*
           * @buyUtils.deferredCancelRequest.promise
           * reset buyUtils.deferredCancelRequest.promise when one has timedout
           *
           */
          buyUtils.deferredCancelRequest.promise.then(
            function() {
              buyUtils.resetDeferredRequest();
            },
            function() {}
          );

          params = params || {};
          var operationFlags = params.operationFlags || {};

          params.extendRequestData = params.extendRequestData || false; // Bool

          // TODO: deprecate @param loading and use params.showProgress instead
          if (loading || params.showProgress) {
            notifier.notify.processing();
          }

          if (!params.extendRequestData) {
            params.data = params.data || buyService.setRequestData(operationName);
          } else {
            angular.extend(params.data, buyService.setRequestData(operationName, params.data));
          }

          params.url = params.url || apis[operationName];

          if (operationName) {
            if (
              brtSwitchCMS.brtSwitch.isHybridFlow &&
              $rootScope.ruiMethods.user.is.agent() &&
              operationName === 'searchCustomerDetails'
            ) {
              var session = buyService.getSession('profile');
              params.data.hybridFlow = true;
              params.data.submitted = session && session.creditCheck && session.creditCheck.__completed;
            }

            if (
              brtSwitchCMS.brtSwitch.isHybridFlow &&
              $rootScope.ruiMethods.user.is.agent() &&
              operationName === 'creditCheck'
            ) {
              var session = buyService.getSession('profile');
              params.data = {
                submitted: session && session.creditCheck && session.creditCheck.__completed
              };
            }

            if (
              brtSwitchCMS.brtSwitch.isHybridFlow &&
              $rootScope.ruiMethods.user.is.agent() &&
              operationName === 'availableTimeslots'
            ) {
              $timeout(function() {
                var res = {
                  getTimeSlot: {
                    nextOperation: 'gotoFulfillment',
                    error: '',
                    timeSlots: createTimeslots(
                      moment(params && params.data && params.data.date ? params.data.date : null).startOf('day')
                    )
                  }
                };
                deferred.resolve(res);
                buyService.parseOperationResponse('availableTimeslots', res, operationFlags);
              }, 0);
            } else if (
              brtSwitchCMS.brtSwitch.isHybridFlow &&
              $rootScope.ruiMethods.user.is.agent() &&
              operationName === 'fulfillmentOptions'
            ) {
              $timeout(function() {
                var res = {
                  options: { techInstall: 'TN', shipToAddress: 'CO', pickupAtStore: 'RE', takeItWithYou: null },
                  error: '',
                  currentDate: moment().utc(),
                  nextOperation: 'availableTimeslots'
                };

                var fulfillmentSession = buyService.getSession('fulfillment');

                if (!fulfillmentSession) {
                  fulfillmentSession = createSession('fulfillment', res);
                  console.log('@buyService:fulfillmentOptions:IF', fulfillmentSession);
                } else {
                  console.log('@buyService:fulfillmentOptions:ELSE', fulfillmentSession);
                  fulfillmentSession = angular.extend(getSession('fulfillment'), {
                    options: res.options,
                    date: res.currentDate
                  });
                }

                // buyService.saveSession('fulfillment', fulfillmentSession);

                // buyService[res.nextOperation]();

                deferred.resolve(res);
                buyService.parseOperationResponse('fulfillmentOptions', res, operationFlags);
              }, 0);
            } else if (
              brtSwitchCMS.brtSwitch.isHybridFlow &&
              $rootScope.ruiMethods.user.is.agent() &&
              operationName === 'validateCart'
            ) {
              $timeout(function() {
                var res = {
                  validateCart: {
                    error: '',
                    nextOperation: 'fulfillmentOptions'
                  }
                };
                deferred.resolve(res);
                buyService.parseOperationResponse('validateCart', res, operationFlags);
              }, 0);
            } else {
              var config = {
                url: params.url,
                method: params.method || 'POST',
                data: params.data || {},
                timeout: buyUtils.deferredCancelRequest.promise
              };

              $http(config)
                .success(function(res, status, headers, config) {
                  if (angular.isUndefined(res.error) && operationName === 'validateCart' && res.validateCart.error) {
                    _satellite.setVar('error', 'FHSI | handle validate cart error');
                    _satellite.track('bfa-fhsi-error');
                    console.log('should handle validate cart error. Response: ', res);

                    // handle validateCart error
                    notifier.notify.error({ errorCode: res.error });
                    return;
                  } else if (operationName === 'availableTimeslots' && res.getTimeSlot.error) {
                    // handle availableTimeslots error
                    _satellite.setVar('error', 'FHSI | availableTimeslots error');
                    _satellite.track('bfa-fhsi-error');

                    deferred.reject(res.getTimeSlot.error);

                    notifier.notify.error({ errorCode: res.getTimeSlot.error });
                    return;
                  } else if (
                    operationName === 'creditCheck' &&
                    res.getCreditInformation &&
                    res.getCreditInformation.error
                  ) {
                    // handle creditCheck error
                    _satellite.setVar('error', 'FHSI | creditCheck error');
                    _satellite.track('bfa-fhsi-error');

                    deferred.reject(res.getCreditInformation.error);

                    notifier.notify.error({ errorCode: res.getCreditInformation.error });
                    return;
                  } else if (operationName === 'creditCheck' && res.error) {
                    _satellite.setVar('error', 'FHSI | creditCheck error');
                    _satellite.track('bfa-fhsi-error');
                    deferred.reject(res.error);

                    if (
                      brtSwitchCMS.brtSwitch.isHybridFlow &&
                      $rootScope.ruiMethods.user.is.agent() &&
                      res.error === '1049581'
                    ) {
                      notifier.notify.done();
                      uteModal.open({
                        templateUrl: 'modules/checkout/views/credential-exist-modal.html',
                        controller: 'CredentialExistModalCtrl',
                        backdrop: 'static',
                        keyboard: false,
                        data: {
                          errorCode: res.error
                        }
                      });
                      return;
                    }

                    if (res.error) {
                      switch (res.error) {
                        case '600015':
                          notifier.notify.done();
                          uteModal.open({
                            templateUrl: 'modules/checkout/views/credential-exist-modal.html',
                            controller: 'CredentialExistModalCtrl',
                            backdrop: 'static',
                            keyboard: false,
                            data: {
                              errorCode: res.error
                            }
                          });
                          return;
                        default:
                          notifier.notify.error({ errorCode: res.error });
                      }
                    }
                    return;
                  } else if (res.error) {
                    console.log('should handle regular error response. Response: ', res);
                    _satellite.setVar('error', 'FHSI | should handle regular error response. Response');
                    _satellite.track('bfa-fhsi-error');

                    switch (operationName) {
                      case 'searchCustomerDetails':
                      case 'createContact':
                        console.log('@doOperation:case 600012', res);
                        if (res.error === '600012') {
                          notifier.notify.done();

                          uteModal.open({
                            templateUrl: 'modules/checkout/views/credential-exist-modal.html',
                            controller: 'CredentialExistModalCtrl',
                            backdrop: 'static',
                            keyboard: false,
                            data: {
                              errorCode: res.error
                            }
                          });

                          return;
                        }
                        break;
                      default:
                    }

                    notifier.notify.error({ errorCode: res.error });
                    _satellite.setVar('error', 'FHSI | should handle regular error response. Response');
                    _satellite.track('bfa-fhsi-error');

                    return;
                  }

                  deferred.resolve(res);

                  // parse the response object
                  // and trigger the next operation
                  buyService.parseOperationResponse(operationName, res, operationFlags);
                })
                .error(function(res, status) {
                  console.log('@doOperation.reject (res, arguments)', res, arguments);
                  _satellite.setVar('error', 'FHSI | @doOperation.reject (res, arguments)');
                  _satellite.track('bfa-fhsi-error');

                  deferred.reject(res);

                  switch (status) {
                    case 400:
                      notifier.notify.error({ errorCode: res.error });
                      return;
                    case 500:
                    case 5000:
                    case 50000:
                      notifier.notify.error({ errorCode: status });
                      return;
                    default:
                  }
                  notifier.notify.error();
                });
            }
          }

          return deferred.promise;
        },
        parseOperationResponse: function(currentOperation, responseData, operationFlags) {
          var nextOperationName = '';
          var allowNextOperation = true;

          // parse response object
          // then trigger nextOperation()

          // actions specific to operation
          if (currentOperation) {
            var fulfillmentSession = buyService.getSession('fulfillment');

            switch (currentOperation) {
              case 'fulfillmentOptions':
                // cache type of fulfillment option
                if (!fulfillmentSession) {
                  fulfillmentSession = createSession('fulfillment', {
                    options: responseData.options,
                    date: responseData.currentDate
                  });
                  console.log('@buyService:fulfillmentOptions:IF', fulfillmentSession);
                } else {
                  console.log('@buyService:fulfillmentOptions:ELSE', fulfillmentSession);
                  fulfillmentSession = angular.extend(getSession('fulfillment'), { options: responseData.options });
                }

                buyService.saveSession('fulfillment', fulfillmentSession);
                break;

              case 'availableTimeslots':
                // cache time-slots
                if (fulfillmentSession) {
                  fulfillmentSession = angular.extend(getSession('fulfillment'), {
                    timeSlots: responseData.getTimeSlot.timeSlots
                  });
                }

                buyService.saveSession('fulfillment', fulfillmentSession);
                console.log('@buyService:$BROADCASTING Fulfillment:TimeSlots:Updated');
                $rootScope.$broadcast('Fulfillment:TimeSlots:Updated', {
                  timeSlots: getSession('fulfillment').timeSlots
                });
                break;
              case 'creditCheck':
                if (responseData.getCreditInformation.en.isCreditCheckPassed === 'true') {
                  console.log('responseData.nextOperation;');
                  console.log(responseData.nextOperation);
                  // deferred.resolve({nextOperation:responseData.nextOperation});
                  // buyService[responseData.nextOperation]();
                  _satellite.setVar('creditcheck', 'Credit check sucess');
                  _satellite.track('bfa-fhsi-credit');
                  nextOperationName = responseData.nextOperation;
                } else if (responseData.getCreditInformation.en.isFraud === 'true') {
                  // should redirect to home page, then
                  // show modal with credit-check result
                  // onModalClose empty cart
                  // deferred.resolve({riskClass:'FRAUD'});
                  $rootScope.$broadcast('CreditCheck:HasRiskClass', {
                    riskClass: 'FRAUD',
                    riskClassCode: responseData.riskClass
                  });
                  notifier.notify.done();
                  return;
                } else if (responseData.getCreditInformation.en.isManualReviewRequired === 'true') {
                  // deferred.resolve({riskClass:'MANUAL_REVIEW'});
                  $rootScope.$broadcast('CreditCheck:HasRiskClass', {
                    riskClass: 'MANUAL_REVIEW',
                    riskClassCode: responseData.riskClass
                  });
                  notifier.notify.done();
                  return;
                } else if (responseData.getCreditInformation.en.isPACOnly === 'true') {
                  // deferred.resolve({riskClass:'CONDITIONAL_APPROVAL'});

                  // EC-5381
                  // HSI - Buy - Update Consumer and CFA risk class messages
                  // > conditional-approval cases is similar to auto-approval
                  _satellite.setVar('creditcheck', "riskClass:'CONDITIONAL_APPROVAL'");
                  _satellite.track('bfa-fhsi-credit');
                  nextOperationName = responseData.nextOperation;

                  // $rootScope.$broadcast('CreditCheck:HasRiskClass', {riskClass:'CONDITIONAL_APPROVAL', riskClassCode: responseData.riskClass});
                  // notifier.notify.done();
                  // return;
                } else if (responseData.getCreditInformation.en.isNegativeCase === 'true') {
                  // negative case but is not fraud; can resubmit
                  // deferred.resolve({riskClass:'NEGATIVE'});
                  $rootScope.$broadcast('CreditCheck:HasRiskClass', {
                    riskClass: 'NEGATIVE',
                    riskClassCode: responseData.riskClass
                  });
                  notifier.notify.done();
                  return;
                }
                break;
              case 'searchCustomerDetails':
                // if cbpExist=true => trigger a negative case
                // > show a call-care modal

                console.log(
                  '@buyService:parseOperationResponse:case=searchCustomerDetails:@responseData ',
                  responseData
                );
                if (responseData.cbpExist) {
                  $rootScope.$broadcast('SearchCustomerDetails:CBPExist');
                  return;
                } else if (responseData.existingCustomer) {
                  // handle existingCustomer=true
                  // show an option to user to login
                  notifier.notify.done();

                  uteModal.open({
                    templateUrl: 'modules/checkout/views/credential-exist-modal.html',
                    controller: 'CredentialExistModalCtrl',
                    backdrop: 'static',
                    keyboard: false,
                    data: {
                      errorCode: responseData.error
                    }
                  });

                  return;
                }
                break;

              default:
            }
          } // if currentOperation

          if (responseData && responseData.nextOperation) {
            // if nextOperation key is in root of response
            nextOperationName = responseData.nextOperation;
          } else {
            // get first key and check for nextOperation key
            _.each(Object.keys(responseData), function(key) {
              // check if nextOperation key is in the second inner object
              if ('nextOperation' in responseData[key]) {
                nextOperationName = responseData[key].nextOperation;
              }
            });
          }

          if (nextOperationName) {
            switch (nextOperationName) {
              case 'gotoFulfillment':
                console.log(
                  '@buyService:parseOperationResponse():case:gotoFulfillment, nextOperationName ',
                  $state.current,
                  nextOperationName
                );
                notifier.notify.done();

                // on editPackage > when on edit-mode > goto last incomplete step
                if ($state.current.name === 'cartSummary' && buyService.hasSession()) {
                  $state.go('buy');
                } else {
                  // applies on anonymous flow
                  $rootScope.$broadcast('Checkout:CompleteStep', { stepName: 'creditCheck' });
                }

                break;

              default:
                buyService.doOperation(nextOperationName);
            }
          }
        },
        setRequestData: function(operationName, params) {
          var _prov = buyUtils.getAppRegion();
          params = params || {};

          var requestConfigs = {
            fulfillmentOptions: {
              regionCode: _prov.toUpperCase(),
              userId: $rootScope.atg.userId.value,
              hashKey: $rootScope.atg.hashKey.value,
              samKey: $rootScope.userPref.samKey
            },
            availableTimeslots: {
              regionCode: _prov.toUpperCase(),
              userId: $rootScope.atg.userId.value,
              hashKey: $rootScope.atg.hashKey.value,
              samKey: $rootScope.userPref.samKey,
              serviceRequiredDate: !params.date ? moment().format('YYYY-MM-D') : params.date,
              selectedFulfillmentOption: getSession('fulfillment')
                ? getSession('fulfillment').options.techInstall
                : null,
              existing: this.setAvailableTimeSlotsRequestFlag('existing', {
                date: !params.date ? moment().format('YYYY-MM-D') : params.date
              })
            },
            validateCart: {
              actionType: 'validateCart',
              userId: $rootScope.atg.userId.value,
              samKey: $rootScope.userPref.samKey,
              hashKey: $rootScope.atg.hashKey.value
            }
          };

          if (operationName && operationName in requestConfigs) {
            return requestConfigs[operationName];
          } else {
            console.log('@buyService:setRequestData:No request config found for operation: ', operationName);
            return undefined;
          }
        },
        setAvailableTimeSlotsRequestFlag: function(flag, params) {
          params = params || {};
          params.date = params.date || '';

          /*
           * @method setAvailableTimeSlotsRequestFlag
           * @description handle setting dynamic value when requesting availableTimeslots depending on which steps are completed
           *
           * @description handle 'existing' flag Boolean
           * false (By default)
           * true (when cx selects different date other than default date)
           * false (edit tech install date from review order page)
           *
           */

          if (flag && params.date) {
            switch (flag) {
              case 'existing':
                var defaultDate, requestedDate;
                if (getSession('fulfillment')) {
                  defaultDate = moment(getSession('fulfillment').date).format('YYYY-MM-D');
                  requestedDate = moment(params.date).format('YYYY-MM-D');

                  return angular.equals(defaultDate, requestedDate) ? false : true;
                }
                break;
              default:
            }
          }
        },

        parseHTTPErrorResponse: function(resp, status) {
          if (status) {
            switch (status) {
              case 500:
              case 5000:
              case 50000:
                _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                _satellite.track('bfa-fhsi-error');
                notifier.notify.error({ errorCode: status });
                return;
                break;
              default:
            }
            notifier.notify.error();
          }
        },

        searchCreditCard: function() {
          var deferred = $q.defer();

          $http
            .get(uteEndpoint('v1/searchCreditCard'))
            .success(function(res) {
              if (res.error) {
                _satellite.setVar('error', 'FHSI | searchCreditCard  failed');

                _satellite.track('bfa-fhsi-error');

                notifier.notify.error({ errorCode: res.error });
                deferred.reject(res);
                return;
              }

              deferred.resolve(res);
            })
            .error(function(res, status) {
              switch (status) {
                case 500:
                case 5000:
                case 50000:
                  notifier.notify.error({ errorCode: status });
                  return;
                default:
                  notifier.notify.error();
              }

              deferred.reject(res);
            });

          return deferred.promise;
        },

        cancelCheckout: function() {
          var _prov = buyUtils.getAppRegion();
          var deferred = $q.defer();
          var data = {
            regionCode: _prov.toUpperCase(),
            userId: $rootScope.atg.userId.value,
            samKey: $rootScope.userPref.samKey,
            hashKey: $rootScope.atg.hashKey.value
          };
          $http
            .post(uteEndpoint('cancelCheckout'), data)
            .success(function(res) {
              if (!res.error) {
                deferred.resolve(res);
              } else {
                _satellite.setVar('error', 'FHSI | cancelCheckout  failed');

                _satellite.track('bfa-fhsi-error');

                deferred.reject(res);
              }
            })
            .error(function(res, status) {
              switch (status) {
                case 500:
                case 5000:
                case 50000:
                  notifier.notify.error({ errorCode: status });
                  return;
                default:
                  notifier.notify.error();
              }

              deferred.reject(res);
            });

          return deferred.promise;
        },

        searchAddress: function(data, type) {
          data = data || {};

          data.addressType = type;

          var deferred = $q.defer();

          if (data && data.addressType) {
            notifier.notify.processing();

            $http
              .post(uteEndpoint('v1/searchAddress'), data)
              .success(function(res) {
                if (res.error) {
                  _satellite.setVar('error', 'FHSI | searchAddress  failed');

                  _satellite.track('bfa-fhsi-error');

                  // handel error
                  notifier.notify.done();
                  deferred.reject(res);
                } else {
                  if (res.addressExisting) {
                    deferred.resolve(res);
                  } else {
                    notifier.notify.done();
                    // reject promise if not mailable
                    deferred.reject(res);
                  }
                }
              })
              .error(function(res, status) {
                switch (status) {
                  case 500:
                  case 5000:
                  case 50000:
                    notifier.notify.error({ errorCode: status });
                    return;
                  default:
                    notifier.notify.error();
                }

                deferred.reject({ data: res, status: status });
              });
          }

          return deferred.promise;
        },

        // fulfillment methods
        fulfillmentOptions: function() {
          console.log('GGGGGGGGGGGGGGGGGGGGGGGGGGGGGG');
          var _prov = buyUtils.getAppRegion();
          var req = {
            regionCode: _prov.toUpperCase(),
            userId: $rootScope.atg.userId.value,
            hashKey: $rootScope.atg.hashKey.value,
            samKey: $rootScope.userPref.samKey
          };

          var fulfillmentSession = buyService.getSession('fulfillment');

          $http({
            method: 'POST',
            url: apis.fulfillmentOptions,
            data: req,
            timeout: buyUtils.deferredCancelRequest.promise
          })
            .success(function(res, status, headers, config) {
              console.log('@buyService:fulfillmentOptions ', res);
              console.log('@buyService:fulfillmentOptions ', fulfillmentSession);

              if (res.error) {
                _satellite.setVar('error', 'FHSI | fulfillmentOptions  failed');

                _satellite.track('bfa-fhsi-error');

                notifier.notify.error({ errorCode: res.error });
                // deferred.reject(res);
              } else {
                // cache type of fulfillment option
                if (!fulfillmentSession) {
                  fulfillmentSession = createSession('fulfillment', {
                    options: res.options,
                    date: res.currentDate
                  });
                  console.log('@buyService:fulfillmentOptions:IF', fulfillmentSession);
                } else {
                  console.log('@buyService:fulfillmentOptions:ELSE', fulfillmentSession);
                  fulfillmentSession = angular.extend(getSession('fulfillment'), {
                    options: res.options
                  });
                }

                buyService.saveSession('fulfillment', fulfillmentSession);

                // deferred.resolve(res);
                buyService[res.nextOperation]();
              }
            })
            .error(function(res, status) {
              switch (status) {
                case 500:
                case 5000:
                case 50000:
                  notifier.notify.error({ errorCode: status });
                  break;
                default:
                  notifier.notify.error();
              }
            });
        },
        gotoFulfillment: function(stepName) {
          stepName = stepName || $state.current.name;

          // buyService.completeStep(stepName);
          $rootScope.$broadcast('Checkout:CompleteStep', { stepName: stepName });
        },

        getOrderSummary: function(data) {
          var _prov = buyUtils.getAppRegion();
          var deferred = $q.defer();

          $http({
            url: uteEndpoint('v1/orderSummary'),
            method: 'POST',
            params: {
              barId: data.billingArrangementId,
              userId: $rootScope.atg.userId.value,
              hashKey: $rootScope.atg.hashKey.value,
              regionCode: _prov.toUpperCase()
            },
            timeout: buyUtils.deferredCancelRequest.promise
          })
            .success(function(res) {
              if (res.error) {
                _satellite.setVar('error', 'FHSI | fulfillmentOptions  failed');

                _satellite.track('bfa-fhsi-error');

                notifier.notify.error({ errorCode: res.error });
                deferred.reject(res);
              } else {
                notifier.notify.done();
                deferred.resolve(res);
              }
            })
            .error(function(res, status) {
              switch (status) {
                case 500:
                case 5000:
                case 50000:
                  notifier.notify.error({ errorCode: status });
                  deferred.reject(res);
                  return;
                default:
                  notifier.notify.error();
              }
              deferred.reject(res);
            });

          return deferred.promise;
        },

        submitfulfillmentOptions: function(params) {
          var _prov = buyUtils.getAppRegion();
          console.log('@buyService:submitfulfillmentOptions(@params) ', params);

          var deferred = $q.defer();

          notifier.notify.processing();

          var req = {
            regionCode: _prov.toUpperCase(),
            userId: $rootScope.atg.userId.value,
            hashKey: $rootScope.atg.hashKey.value,
            samKey: $rootScope.userPref.samKey,
            serviceRequiredDate: params.selectedDate || 'default',
            selectedFulfillmentOption: getSession('fulfillment')
              ? getSession('fulfillment').options[$state.current.name]
              : null
          };

          angular.extend(req, params);

          $http({
            method: 'POST',
            url: apis.submitfulfillmentOptions,
            data: req,
            timeout: buyUtils.deferredCancelRequest.promise
          })
            .success(function(res) {
              if (res.error) {
                _satellite.setVar('error', 'FHSI | submitfulfillmentOptions  failed');
                _satellite.track('bfa-fhsi-error');
                switch ($state.current.name) {
                  case 'takeItWithYou':
                    if (res.error === '60000' || res.error === '60001') {
                      notifier.notify.done();
                    } else {
                      notifier.notify.error({ errorCode: res.error });
                    }

                    break;
                  default:
                    notifier.notify.error({ errorCode: res.error });
                }
                deferred.reject(res);
              } else if (res.continuePayment) {
                notifier.notify.done();
                deferred.resolve(res);
              } else {
                _satellite.setVar('error', 'FHSI | submitfulfillmentOptions  failed');
                _satellite.track('bfa-fhsi-error');

                notifier.notify.error();
              }
            })
            .error(function(res, status) {
              switch (status) {
                case 500:
                case 5000:
                case 50000:
                  notifier.notify.error({ errorCode: status });
                  break;
                default:
                  notifier.notify.error();
              }
            });

          return deferred.promise;
        },

        submitOrder: function() {
          var _prov = buyUtils.getAppRegion();
          if (getSession('profile')) {
            notifier.notify.processing();
          }

          var deferred = $q.defer();

          if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
            var session = getSession('profile');
            var fulfillmentOptionsMapping = {
              techInstall: {
                code: 'TN',
                label: 'Tech Install'
              },
              shipToAddress: {
                code: 'CO',
                label: 'Ship to Address'
              },
              pickupAtStore: {
                code: 'RE',
                label: 'Pick Up At Store'
              },
              takeItWithYou: {
                code: 'NN',
                label: 'Take it With You'
              }
            };
            var fulfillmentSelectedOption = session.fulfillment.selectedOption;
            var formatTime = function(momentTime) {
              return momentTime.format('HH a');
            };
            var formatAddress = function(CPAddress) {
              try {
                return (
                  (CPAddress.unitNumber ? CPAddress.unitNumber + '-' : '') +
                  ' ' +
                  CPAddress.streetNumber +
                  ' ' +
                  CPAddress.streetName +
                  ' ' +
                  CPAddress.streetType +
                  ', ' +
                  ' ' +
                  CPAddress.city +
                  ' ' +
                  CPAddress.province +
                  ', ' +
                  ' ' +
                  CPAddress.postalCode
                );
              } catch (e) {
                return '';
              }
            };

            var serviceAddress = formatAddress(session.createUser.address);
            var shippingAddress = '';

            if (fulfillmentSelectedOption === 'shipToAddress') {
              if (session.fulfillment.options.shipToAddress.shippingAddressOption === 'anotherAddress') {
                // add another address stuff
                shippingAddress = session.fulfillment.options.shipToAddress.anotherAddress;
              } else {
                shippingAddress = serviceAddress;
              }
            }

            var selectedOffer = angular.extend(
              {},
              $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].selectedOffer
            );

            var getOfferCampaignCodes = function(offer) {
              var campaignCodes = [];
              if (offer && offer.hasOwnProperty('discounts') && offer.discounts && offer.discounts.length) {
                angular.forEach(offer.discounts, function(discount) {
                  if (discount.typeName && discount.typeName === 'campaignSku') {
                    campaignCodes.push(discount.campaignCode);
                  }
                });
              }
              return campaignCodes;
            };

            var requestPayload = {
              billingPrefEmail: session.createUser.email_address,
              billingMethod: 'Online',
              paymentMethod: 'Invoice',
              serialNumber:
                fulfillmentSelectedOption === 'takeItWithYou'
                  ? session.fulfillment.options.takeItWithYou.modemSerialNumber
                  : '',
              fulfilOption: fulfillmentOptionsMapping[fulfillmentSelectedOption].label,
              fulfilType: fulfillmentOptionsMapping[fulfillmentSelectedOption].code,
              serviceReqDate: moment().locale("en").format('YYYY-MMM-DD'),
              appointDate:
                fulfillmentSelectedOption === 'techInstall'
                  ? moment(session.fulfillment.options.techInstall.slot.startTime).locale("en").format('YYYY-MMM-DD')
                  : '',
              appointTime:
                fulfillmentSelectedOption === 'techInstall'
                  ? formatTime(moment(session.fulfillment.options.techInstall.slot.startTime)) +
                    ' - ' +
                    formatTime(moment(session.fulfillment.options.techInstall.slot.endTime))
                  : '',
              phoneNoForTech:
                fulfillmentSelectedOption === 'techInstall' ? session.fulfillment.options.techInstall.phone : '',
              notesForTech:
                fulfillmentSelectedOption === 'techInstall' ? session.fulfillment.options.techInstall.instructions : '',
              preferredTime:
                fulfillmentSelectedOption === 'techInstall'
                  ? session.fulfillment.options.techInstall.preferredTime
                  : '',
              productDesc: selectedOffer.maestroProdDesc,
              maestroId: selectedOffer.maestroId ? selectedOffer.maestroId : '',
              campaignCode: getOfferCampaignCodes(selectedOffer).join('|'),
              fulfilCampaign: '',
              billingAddress:
                session.createUser.billingAddress === 'anotherAddress' ? session.createUser.anotherBillingAddress : '',
              serviceAddress: serviceAddress,
              shippingAddress: shippingAddress
            };

            // console.log('SESSSSSSION', session);
            // console.log('payload', requestPayload);
            // console.log(
            //   '$rootScope',
            //   $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].selectedOffer
            // );

            $http({
              url: uteEndpoint('v1/hybrid/submit'), // '/selfserve/v1/hybrid/submit',
              method: 'POST',
              data: requestPayload
              // timeout: buyUtils.deferredCancelRequest.promise
            })
              .success(function(res) {
                deferred.resolve(angular.extend({}, requestPayload, res));
              })
              .error(function(res, status) {
                deferred.resolve(angular.extend({}, requestPayload, res, { error: 'failed_call' }));
              });
          } else {
            $http({
              url: uteEndpoint('v1/submitOrder'),
              method: 'POST',
              params: {
                barId: getSession('profile').paymentOptions.data.billingArrangementId,
                userId: $rootScope.atg.userId.value,
                hashKey: $rootScope.atg.hashKey.value,
                regionCode: _prov.toUpperCase()
              },
              timeout: buyUtils.deferredCancelRequest.promise
            })
              .success(function(res) {
                if (res.error) {
                  switch (res.error) {
                    case '600020':
                      console.log('@buyService:getOrderSummary --IF (res.error) ', res.error);
                      _satellite.setVar('error', 'FHSI | getOrderSummary  failed');
                      _satellite.track('bfa-fhsi-error');

                      $state.go('login');
                      $timeout(function() {
                        uteModal.open({
                          templateUrl: 'modules/checkout/views/credit-check-fraud-modal.html',
                          controller: 'riskClassModalCtrl',
                          data: {
                            riskClassCode: 'NFD2'
                          }
                        });

                        // delete session
                        buyService.deleteCheckoutSession();
                      });
                      break;
                    default:
                      notifier.notify.error({ errorCode: res.error });
                      deferred.reject();
                  }
                } else {
                  notifier.notify.done();
                  deferred.resolve(res);
                }
                //***//
                // if (res.error) {
                //   notifier.notify.error({ errorCode: res.error });
                //   deferred.reject();
                // } else {
                //   notifier.notify.done();
                //   deferred.resolve(res);
                // }
              })
              .error(function(res, status) {
                switch (status) {
                  case 500:
                  case 5000:
                  case 50000:
                    notifier.notify.error({ errorCode: status });
                    return;
                  default:
                    notifier.notify.error();
                }

                deferred.reject();
              });
          }
          return deferred.promise;
        },

        getFulfillmentType: function() {
          // returns `1 if techInstall or `3 if three-tabbed fulfillment options

          if (
            brtSwitchCMS.brtSwitch.isHybridFlow &&
            $rootScope.ruiMethods.user.is.agent() &&
            this.getCableCondition() &&
            this.getCableCondition().toLowerCase() === 'unwired'
          ) {
            return 1;
          }

          if (getSession('fulfillment') && getSession('fulfillment').options) {
            return _.keys(_.pick(getSession('fulfillment').options, _.isString)).length;
          } else {
            _satellite.setVar('error', 'FHSI | getFulfillmentType  failed');
            _satellite.track('bfa-fhsi-error');
            $log.error('@buyService:getFulfillmentType:Cannot find fulfillment options session');
          }
        },

        setTimeSlotsHeader: function(format, timeSlotsObj) {
          var timeSlotsData, slot, timeSlotCount;

          if (
            !timeSlotsObj &&
            !buyService.getSession('fulfillment') &&
            !buyService.getSession('fulfillment').timeSlots
          ) {
            return [];
          }

          timeSlotsData = timeSlotsObj || buyService.getSession('fulfillment').timeSlots;

          if (angular.isObject(timeSlotsData) && !_.isEmpty(timeSlotsData)) {
            timeSlotCount = _.values(timeSlotsData).length -= 1;

            slot = _.chain(timeSlotsData)
              .values()
              .filter(function(av, ai) {
                if (ai === timeSlotCount) {
                  return av;
                }
              })
              .flatten(true)
              .map(function(bv) {
                // return bv.startTime = moment(bv.startTime).format(format);
                return bv.startTime;
              })
              .sortBy(function(cv) {
                return moment(cv).format();
              })
              .value();

            slot = _.take(slot, 5);

            return slot;
          }
        },

        // paymentOptions methods
        createFinancialAccount: function(paramsObj) {
          var deferred = $q.defer();

          $http
            .post(uteEndpoint('v1/createFinancialAccount'), paramsObj.data)
            .success(function(res) {
              if (res.error) {
                // handle error
                _satellite.setVar('error', 'FHSI | createFinancialAccount  failed');

                _satellite.track('bfa-fhsi-error');

                notifier.notify.error({ errorCode: res.error });
                deferred.reject(res);
              } else {
                deferred.resolve(res);
              }
            })
            .error(function(res, status) {
              switch (status) {
                case 500:
                case 5000:
                case 50000:
                  notifier.notify.error({ errorCode: status });
                  return;
                case 400:
                  // NOTE:
                  // commented: not to show modal on a case of 60003 which corresponds to an 'Invalid Bank Info'
                  // notifier.notify.error({errorCode: res.error});

                  // close modal
                  notifier.notify.done();
                  deferred.reject(res);
                  return;
                default:
                  notifier.notify.error();
              }
              deferred.reject(res);
            });

          return deferred.promise;
        },

        requestIndepthEval: function() {
          var deferred = $q.defer();

          notifier.notify.processing();

          $http
            .post(uteEndpoint('v1/createCase'))
            .success(function(res) {
              if (res.error) {
                // handle error
                notifier.notify.error({ errorCode: res.error });
              } else {
                deferred.resolve(res);
              }
            })
            .error(function(res, status) {
              switch (status) {
                case 500:
                case 5000:
                case 50000:
                  notifier.notify.error({ errorCode: status });
                  return;
                default:
                  notifier.notify.error();
              }

              deferred.reject(res);
            });

          return deferred.promise;
        },

        getRiskClassViewContent: function(riskClassCode) {
          var _isAgent = $rootScope.ruiMethods.user.is.agent();

          var retailPrefix = 'retail.',
            consumerPrefix = 'global.',
            baseMessage = 'error.postBack.riskClass.',
            baseMessageDefault = 'error.postBack.riskClass.default',
            tag =
              _isAgent && riskClassCode
                ? retailPrefix.concat(baseMessage, riskClassCode)
                : consumerPrefix.concat(baseMessage, riskClassCode),
            tagDefault = _isAgent ? retailPrefix.concat(baseMessageDefault) : consumerPrefix.concat(baseMessageDefault);

          return $translate(tag).then(
            function(resp) {
              return resp;
            },
            function(resp) {
              return $translate(tagDefault).then(
                function(respDefault) {
                  return respDefault;
                },
                function() {
                  return 'Oopsies...';
                }
              );
            }
          );
        },

        getAgeOfMajority: function() {
          var _prov = buyUtils.getAppRegion();
          return provinceMeta[_prov].ageOfMajority;
        },

        // TODO deprecate and use the getContentWithDynamicContent
        getTechInstallViewMessage: function() {
          var _isLoggedIn = $rootScope.ruiMethods.user.is.loggedIn(),
            _isAgent = $rootScope.ruiMethods.user.is.agent();
          var promise;
          if (_isAgent) {
            promise = $q.when($translate('retail.message.techInstallStep1'));
          } else {
            promise = $q.when($translate('global.message.techInstallStep1'));
          }

          if (promise) {
            return promise;
          }
        },
        parseViewMessageForAgeOfMajority: function(langTag, dContentFlag, dValue) {
          var _isLoggedIn = $rootScope.ruiMethods.user.is.loggedIn(),
            _isAgent = $rootScope.ruiMethods.user.is.agent();
          var promise;

          if (langTag) {
            return $translate(langTag).then(function(resp) {
              if (dContentFlag) {
                return resp.replace(dContentFlag, dValue);
              } else {
                resp;
              }
            });
          }
        },

        parseLangTagFlagForDynamicContent: function(langTag, flag, content) {
          return $translate(langTag).then(function(resp) {
            if (flag && content) {
              return resp.replace(flag, content);
            } else {
              resp;
            }
          });
        },
        getContentWithDynamicContent: function(params) {
          var _isAgent = $rootScope.ruiMethods.user.is.agent();
          params = params || {};
          params.tags = params.tags || {}; // user if dealing if cfa or consumer together
          params.tag = params.tag || ''; // user if one tag only
          params.flag = params.flag || '';
          params.value = params.value || '';

          if (params.tags.hasOwnProperty('retail') && params.tags.hasOwnProperty('consumer')) {
            // if object check if is agent
            if (_isAgent) {
              return buyService.parseLangTagFlagForDynamicContent(params.tags.retail, params.flag, params.value);
            } else {
              return buyService.parseLangTagFlagForDynamicContent(params.tags.consumer, params.flag, params.value);
            }
          } else if (params.tag) {
            return buyService.parseLangTagFlagForDynamicContent(params.tag, params.flag, params.value);
          }
        },
        isAccountEligibleToCheckout: function() {
          var accounts = [],
            user;

          // debug
          // if (true) {
          // debug end
          if ($rootScope.userInfo && $rootScope.userInfo.accounts) {
            accounts = $rootScope.userInfo.accounts;

            // debug
            // accounts = [
            //   {
            //     accountNumber : "761493907",
            //     accountOrder : "5",
            //     contactId : null,
            //     delinquentStatus : null,
            //     fidoGuid : null,
            //     reasonCode : null,
            //     serviceName : "Wireless",
            //     serviceNameLabel : "Mobile",
            //     status : "Open",
            //   },
            //   // {
            //   //   status: 'active',
            //   //   serviceName: 'wireless',
            //   //   accountNumber: '2423049203948'
            //   // }
            //   // {
            //   //   status: 'ACTIVE',
            //   //   serviceName: 'Internet/TV'
            //   // }
            // ];
            // end debug

            // user has internet account cannot proceed to buy-flow
            if (_.find(accounts, { serviceName: internetTvFlag })) {
              return false;
            }
            if (_.find(accounts, { serviceName: internetFlag })) {
              return false;
            }

            user = _.chain(accounts)
              .map(function(s) {
                // we might receive inconsistencies of the format from SS
                // we set the status value to lower-case each time
                s.status = s.status ? s.status.toLowerCase() : s.status;
                s.serviceName = s.serviceName ? s.serviceName.toLowerCase() : s.serviceName;
                // console.log('--@buyService:isAccountEligibleToCheckout (_.map @param) ', s);
                return s;
              })
              .filter(function(v) {
                // WIRELESS account that is ACTIVE or OPEN can buy

                if (
                  (v.status === statusOpenFlag.toLowerCase() && v.serviceName === wirelessFlag.toLowerCase()) ||
                  (v.status === statusActiveFlag.toLowerCase() && v.serviceName === wirelessFlag.toLowerCase())
                )
                  return v;
              })
              .value();

            // if user:array length is not 0
            // then an eligible user is found
            return user.length != 0;
          }

          return false;
        },
        _mod_isAccountEligibleToCheckout: function(context) {
          // context: [tv, internet]

          context = $state.current.name;
          var userAccounts,
            checkRequirements = [],
            checkRestrictions = [];

          if ($rootScope.userInfo && $rootScope.userInfo.accounts) {
            // userAccounts = $rootScope.userInfo.accounts;
            userAccounts = [
              {
                status: 'open',
                serviceName: 'wireless',
                accountNumber: '2423049203948'
              },
              {
                status: 'ACTIVE',
                serviceName: 'Internet/TV'
              }
            ];
          }

          var store = {
            internet: {
              requiredService: [],
              requiredServiceStatus: ['open', 'active'],
              restrictedService: ['internet', 'internet/tv'],
              restrictedServiceStatus: ['open', 'active']
            },
            tvPackages: {
              requiredService: ['internet', 'internet/tv'],
              requiredServiceStatus: ['open', 'active'],
              restrictedService: [],
              restrictedServiceStatus: []
            }
          };

          var checkEquality = function(serviceContext, serviceCheckFlag, checkContext) {
            if (!serviceContext.length) {
              if (checkContext === 'req') {
                return true;
              } else {
                return false;
              }
            } else {
              console.log('----a ', serviceContext, serviceCheckFlag, _.contains(serviceContext, serviceCheckFlag));
              return _.contains(serviceContext, serviceCheckFlag);
            }
          };

          if (context in store && userAccounts) {
            _.each(userAccounts, function(v) {
              if (
                checkEquality(store[context].requiredServiceStatus, angular.lowercase(v.status), 'req') &&
                checkEquality(store[context].requiredService, angular.lowercase(v.serviceName), 'req')
              )
                checkRequirements.push(v);

              if (
                checkEquality(store[context].restrictedService, angular.lowercase(v.serviceName)) &&
                checkEquality(store[context].restrictedServiceStatus, angular.lowercase(v.status))
              )
                checkRestrictions.push(v);
            });
            console.log('----1 ', checkRequirements);
            console.log('----2 ', checkRestrictions);
            console.log('----3 ', checkRequirements.length > 0 && !checkRestrictions.length);

            return checkRequirements.length > 0 && !checkRestrictions.length;
          }
        },
        old_isEligibleToCheckout: function() {
          /*
           * IMPORTANT CLEANUP NOTE:
           * This FUNCTION is a part of brtswitch and need to be deleted after release
           * along with the accompanying files defined in index.html:
           *
           * <script src="modules/old-core/old-coreModule.js"></script>
           * <script src="modules/old-core/controllers/old-availabilityModalCtrl.js"></script>
           */

          var _activeUserType, _profileType;

          if ($rootScope.ruiMethods.user.is.loggedIn()) {
            /*
             * handle logged in
             */
            _profileType = $rootScope.userInfo.profileType;
          } else if (
            $rootScope.ruiMethods.user.is.agent() &&
            $rootScope.userInfo &&
            $rootScope.userInfo.cfaInfo &&
            $rootScope.userInfo.cfaInfo.getCustomerAccounts &&
            $rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType
          ) {
            /*
             * handle cfa w cx context
             */
            _profileType = $rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType;
          } else if (
            $rootScope.ruiMethods.user.is.agent() &&
            $rootScope.userInfo &&
            $rootScope.userInfo.cfaInfo &&
            $rootScope.userInfo.cfaInfo.getCustomerAccounts &&
            !$rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType
          ) {
            /*
             * handle cfa anonymous
             * @description agent going to portal without customer context will not have
             * the property 'profileType' in 'getCustomerAccounts'
             */
            return null;
          }

          /*
           * handle default case
           * always show as eligible
           */
          // if (angular.isUndefined(_profileType)) return true;

          // debug
          // _profileType = {
          //   groupId: false,
          //   owner: false,
          //   prepaid: true,
          //   subscriber: false
          // };
          // end debug

          // debug
          // for (_activeUserType in _profileType) {
          // console.log('@buyService:isEligibleToCheckout BEFORE IF _profileType[_activeUserType]', _profileType[_activeUserType]);
          // end debug

          for (_activeUserType in _profileType) {
            /*
             * get profileType `key which has value of `true
             */
            if (_profileType[_activeUserType]) {
              // debug
              // if (_profileType[_activeUserType]) {
              // end debug
              // console.log('@buyService:isEligibleToCheckout BEFORE SWITCH');

              switch (_activeUserType) {
                case 'groupId':
                case 'owner':
                  /*
                   * if already logged in and no previous checkout session
                   * proceed to create profile
                   */
                  return buyService.isAccountEligibleToCheckout() && true;

                  break;
                case 'prepaid':
                case 'subscriber':
                  // console.log('@buyService:isEligibleToCheckout CASE PREPAID OR SUBSCRIBER');
                  /*
                   * show call care modal
                   */
                  return buyService.isAccountEligibleToCheckout() && false;

                  break;
                default:
              }

              // /if
            }
            // /for in
          }
        },
        isEligibleToCheckout: function() {
          var _activeUserType, _profileType;

          if ($rootScope.ruiMethods.user.is.loggedIn()) {
            /*
             * handle logged in
             */
            _profileType = $rootScope.userInfo.profileType;
          } else if (
            $rootScope.ruiMethods.user.is.agent() &&
            $rootScope.userInfo &&
            $rootScope.userInfo.cfaInfo &&
            $rootScope.userInfo.cfaInfo.getCustomerAccounts &&
            $rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType
          ) {
            /*
             * handle cfa w cx context
             */
            _profileType = $rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType;
          } else if (
            $rootScope.ruiMethods.user.is.agent() &&
            $rootScope.userInfo &&
            $rootScope.userInfo.cfaInfo &&
            $rootScope.userInfo.cfaInfo.getCustomerAccounts &&
            !$rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType
          ) {
            /*
             * handle cfa anonymous
             * @description agent going to portal without customer context will not have
             * the property 'profileType' in 'getCustomerAccounts'
             */
            return true;
          } else if (!$rootScope.ruiMethods.user.is.loggedIn() && !$rootScope.ruiMethods.user.is.agent()) {
            return false;
          }

          /*
           * handle default case
           * always show as eligible
           */
          // if (angular.isUndefined(_profileType)) return true;

          // debug
          // _profileType = {
          //   ctn: true,
          //   groupId : false,
          //   owner : false,
          //   prepaid : true,
          //   subscriber: false
          // };
          // _profileType = {
          //   groupId: false,
          //   owner: false,
          //   prepaid: true,
          //   subscriber: false
          // };
          // end debug

          // debug
          // for (_activeUserType in _profileType) {
          // console.log('@buyService:isEligibleToCheckout BEFORE IF _profileType[_activeUserType]', _profileType[_activeUserType]);
          // end debug

          for (_activeUserType in _profileType) {
            /*
             * get profileType `key which has value of `true
             */
            if (_profileType[_activeUserType]) {
              // debug
              // if (_profileType[_activeUserType]) {
              // end debug
              // console.log('@buyService:isEligibleToCheckout BEFORE SWITCH');

              switch (_activeUserType) {
                case 'groupId':
                case 'owner':
                case 'prepaid': // 2017 Enhancements - HSI AUTOMATED BUYFLOW
                case 'subscriber': // 2017 Enhancements - HSI AUTOMATED BUYFLOW
                  /*
                   * if already logged in and no previous checkout session
                   * proceed to create profile
                   */
                  return buyService.isAccountEligibleToCheckout() && true;

                  break;
                // case 'subscriber':
                //   // console.log('@buyService:isEligibleToCheckout CASE PREPAID OR SUBSCRIBER');
                //   /*
                //    * show call care modal
                //    */
                //   return (buyService.isAccountEligibleToCheckout() && false);
                //   break;
                default:
              }

              // /if
            }
            // /for in
          }

          // handle accounts without profileType and proceed to checkout
          return true;
        },
        isAccountEligibleForTvCheckout: function() {
          if (commonService.customerHasTVService) return false;
          if (commonService.customerHasInternetService) return true;
          return false;
        },
        isEligibleToTvCheckout: function() {
          //var _activeUserType,
          //    _profileType;
          //
          //if ($rootScope.ruiMethods.user.is.loggedIn()) {
          //  _profileType = $rootScope.userInfo.profileType;
          //} else if ($rootScope.ruiMethods.user.is.agent() && $rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.getCustomerAccounts && $rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType) {
          //  _profileType = $rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType;
          //} else if ($rootScope.ruiMethods.user.is.agent() && $rootScope.userInfo && $rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.getCustomerAccounts && !$rootScope.userInfo.cfaInfo.getCustomerAccounts.profileType) {
          //  return null;
          //}
          //for (_activeUserType in _profileType) {
          //  if (_profileType[_activeUserType]) {
          //    switch (_activeUserType) {
          //      case 'groupId':
          //      case 'owner':
          //        return (buyService.isAccountEligibleForTvCheckout() && true);
          //        break;
          //      case 'prepaid':
          //      case 'subscriber':
          //        return false;
          //        break;
          //      default:
          //    }
          //  }
          //}
          return true;
        },
        getPaymentDetails: function(accountNumber) {
          if (accountNumber) {
            notifier.notify.processing();

            return $http
              .post(apis.getPaymentDetails, { accountNumber: accountNumber })
              .error(function(resp, status) {
                // confirm not to show error message when request failed

                notifier.notify.done();
              })
              .success(function(resp, status) {
                // confirm not to show error message when request failed

                notifier.notify.done();
              });
          }
        },
        getAccountNumberByServiceName: function(serviceName) {
          var accounts, accountNumber;
          if (
            $rootScope.ruiMethods.user.is.loggedIn() &&
            $rootScope.userInfo &&
            $rootScope.userInfo.accounts &&
            $rootScope.userInfo.accounts.length &&
            serviceName
          ) {
            accounts = $rootScope.userInfo.accounts;
            // debug
            // accounts = [
            //   {
            //     status: 'open',
            //     serviceName: 'wireless',
            //     accountNumber: '2423049203948'
            //   },
            //   // {
            //   //   status: 'ACTIVE',
            //   //   serviceName: 'Internet/TV'
            //   // }
            // ];
            // end debug

            accountNumber = _.result(_.find(accounts, { serviceName: serviceName.toLowerCase() }), 'accountNumber');
            return accountNumber;
          }
        },

        /*
         * @name getPermission
         * @return Boolean
         */
        getPermission: function(key, data) {
          var requestIndepthEvalOptionRestricted = ['IN75', 'IN58', 'EH15'],
            callCareOptionEnabled = [
              'EH09',
              'EH10',
              'EH11',
              'EN14',
              'EH04',
              'EH24',
              'EN84',
              'EN24',
              'EH20',
              'EN25',
              'FN79',
              'FN81',
              'FN82',
              'FN83',
              'FN84',
              'NFD1',
              'NFD2',
              'IN75'
            ];

          if (key && data) {
            switch (key) {
              case 'requestIndepthEvaluation':
                if (data.riskClassCode) {
                  return requestIndepthEvalOptionRestricted.indexOf(data.riskClassCode) >= 0 ? false : true;
                }
                break;
              case 'callCare':
                /*
                 * case `callCare
                 * @description handle visibility of call-care element depending on risk-class code
                 * cfa + those risk-class => call-care only
                 * cx + those risk-class => call-care & live-chat
                 * cfa + rest of the risk-class => no call-care & no live-chat
                 *
                 * Story:
                 * EC-5381 HSI - Buy - Update Consumer and CFA risk class messages
                 *
                 */
                if (data.riskClassCode) {
                  return callCareOptionEnabled.indexOf(data.riskClassCode) !== -1 ? true : false;
                }
                break;
              default:
                console.log('@getPermission case default');
                return false;
            }
          } else {
            $log.warn('@getPermission invalid args');
            return false;
          }
        },

        getAppLang: function() {
          var _lang = buyUtils.getAppLang();
          return _lang;
        },
        getCurrentUserType: function() {
          if (
            $rootScope.ruiMethods &&
            $rootScope.ruiMethods.user &&
            $rootScope.ruiMethods.user.is &&
            _.isFunction($rootScope.ruiMethods.user.is.agent) &&
            _.isFunction($rootScope.ruiMethods.user.is.loggedIn)
          ) {
            return {
              isAgent: $rootScope.ruiMethods.user.is.agent(),
              isLoggedIn: $rootScope.ruiMethods.user.is.loggedIn(),
              isAuth: $rootScope.ruiMethods.user.is.agent() || $rootScope.ruiMethods.user.is.loggedIn()
            };
          }
        },
        getCartContext: function() {
          var shoppingCartServices;
          if (
            $rootScope.shoppingCart &&
            $rootScope.shoppingCart[buyService.getAppLang()] &&
            $rootScope.shoppingCart[buyService.getAppLang()].services
          ) {
            shoppingCartServices = $rootScope.shoppingCart[buyService.getAppLang()].services;
            for (var context in shoppingCartServices) {
              if (
                _.isObject(shoppingCartServices[context]) &&
                shoppingCartServices[context].quantity &&
                shoppingCartServices[context].quantity > 0
              ) {
                return context;
              }
            } // /for
          }
        },

        sudoCheckout: function(config) {
          config = config || {};
          config.createUser = config.createUser || false;
          config.creditCheck = config.creditCheck || false;
          config.fulfillment = config.fulfillment || false;
          config.review = config.review || false;

          $http.get(apis.sessionFulfillmentOptions).success(function(data) {
            buyService.saveSession('fulfillment', data);
          });
          $http.get(apis.sessionConfirmation).success(function(data) {
            buyService.saveSession('confirmation', data);
          });

          $http.get(apis.sessionCheckout).success(function(data) {
            if (config) {
              for (var step in config) {
                if (step) {
                  data[step].__completed = config[step];
                }
              }
            } else {
            }

            console.log('+++ sudoCheckout ', data);

            buyService.saveSession(sessionKey, data);
          });
        },
        mockShoppingCart: function() {
          $http.get('http://localhost:8888/resource/internetShoppingCart.json').success(function(resp) {
            $rootScope.shoppingCart = angular.copy(resp);
          });
        },
        mockSelectedOffer: function() {
          return {
            tierId: 'cat10007',
            name: 'Tier 1',
            speed: {
              download: 15,
              downloadUnit: 'MBPS',
              upload: 1,
              uploadUnit: 'MBPS'
            },
            products: [
              {
                id: 'prod10005',
                offers: [
                  {
                    offerId: 'sku10004',
                    name: 'Fido Internet (FD10)',
                    offerPrice: {
                      price: 53.99,
                      priceFrequency: 'monthly'
                    },
                    rentalModem: true,
                    additionalPrice: {
                      price: null,
                      priceFrequency: null
                    },
                    overagePrice: 100,
                    overageUnit: 'MB',
                    overage: 3,
                    content: {
                      offerDetails: null
                    },
                    usageAllowance: '200 GB',
                    tierId: 'cat10007',
                    productId: 'prod10005'
                  }
                ]
              }
            ],
            selectedOffer: {
              offerId: 'sku10004',
              name: 'Fido Internet (FD10)',
              offerPrice: {
                price: 53.99,
                priceFrequency: 'monthly'
              },
              rentalModem: true,
              additionalPrice: {
                price: null,
                priceFrequency: null
              },
              overagePrice: 100,
              overageUnit: 'MB',
              overage: 6,
              content: {
                offerDetails: null
              },
              usageAllowance: '200 GB',
              tierId: 'cat10007',
              productId: 'prod10005'
            }
          };
        },
        mockRootScope: function(data) {
          var _config = {
            accounts: [
              {
                status: 'ACTIVE',
                serviceName: 'wireless',
                accountNumber: '2423049203948'
              },
              {
                status: 'ACTIVE',
                serviceName: 'Internet/TV',
                accountNumber: '2423049203949'
              }
            ],
            registrationStatus: true,
            creditCardInfo: {
              creditCardNo: '9648158691876566',
              cardType: 'MASTERCARD',
              expiryDate: '2017-05-04'
            },
            firstName: 'MITENA',
            lastName: 'ARRUDA',
            billingAddress: {
              addressLine1: '4001 APPLE CANADA INC T PO BOX 4054 STN',
              addressLine2: '4001 APPLE CANADA INC T PO BOX 4054 STN',
              province: 'ON',
              city: 'TORONTO',
              postalCode: 'M5W3A6',
              name: 'MITENAARRUDA'
            },
            error: '',
            profileType: {
              groupId: false,
              owner: false,
              prepaid: true,
              subscriber: false
            }
          };

          /*
           * Example:
           * buyService.mockRootScope({userInfo: anyObject});
           *
           */

          $rootScope.userInfo = $rootScope.userInfo || {};
          console.log('@mockRootScope/ data ', data);

          angular.extend($rootScope.userInfo, (data && data.userInfo) || _config);
        },

        getInternetPromos: function() {
          var deferred = $q.defer();
          if (internetPromoJson) {
            deferred.resolve(internetPromoJson);
          } else {
            $http.get(apis.promoJSONUrl).then(
              function(response) {
                internetPromoJson = response.data;
                deferred.resolve(response.data);
              },
              function() {
                deferred.reject();
              }
            );
          }
          return deferred.promise;
        },

        isPromoOfferIdEligible: function(offerId) {
          var selectedOffer = angular.extend(
            {},
            $rootScope.shoppingCart[uteLocale.language].services.internet.tier[0].selectedOffer
          );
          if (internetPromoJson && selectedOffer.discounts && selectedOffer.discounts.length > 0) {
            var promoOfferId = 'notEligible';
            angular.forEach(internetPromoJson.products, function(promo) {
              if (promo['offer-id'] === offerId && promo['display_promo_text']) {
                promoOfferId = offerId;
              }
            });
            return promoOfferId;
          } else {
            return null;
          }
        },

        getDiscountOffers: function() {
          if (internetPromoJson) {
            var discounts = internetPromoJson;
            return discounts;
          } else {
            return null;
          }
        },

        getPromoOfferId: function(offerId) {
          if (offerId === 'notEligible') {
            return null;
          } else {
            return offerId;
          }
        }
      };

      return buyService;
    }
  ]);
})();
